export interface TrustSignal {
  icon: string;
  title: string;
  description: string;
}

export const trustSignals: TrustSignal[] = [
  {
    icon: 'ri-refresh-line',
    title: 'Updated Daily',
    description: 'The ACBuy spreadsheet database refreshes every 24 hours with the latest prices, new product arrivals, and current seller ratings — ensuring you never miss a deal.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Verified Listings',
    description: 'Every product in the ACBuy item list is cross-checked against seller history, user reviews, and price consistency before being included in the spreadsheet.',
  },
  {
    icon: 'ri-ai-generate',
    title: 'AI-Ranked Picks',
    description: 'Our intelligent ranking system analyzes thousands of data points to surface the best ACBuy spreadsheet deals — highest quality at the lowest prices.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'User-Rated System',
    description: 'Real buyer ratings and reviews power the comparison engine, so you see what actual shoppers recommend from the ACBuy database.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Transparent Data',
    description: 'No hidden commissions or biased rankings. The ACBuy spreadsheet comparison shows you raw data so you can make your own informed decisions.',
  },
  {
    icon: 'ri-global-line',
    title: 'Global Access',
    description: 'Designed for international buyers, the ACBuy spreadsheet 2026 supports worldwide shipping comparisons and multi-currency price estimates.',
  },
];